"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var flyout_1 = require("spry-react/Flyout/flyout");
var flyoutToggle_1 = require("spry-react/Flyout/flyoutToggle");
var labeled_1 = require("spry-react/Label/labeled");
var lockToggle_1 = require("spry-react/Label/lockToggle");
var link_1 = require("spry-react/Link/link");
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var errorUtils_1 = require("spry-react/utils/errorUtils");
var idGenerator_1 = require("spry-react/utils/idGenerator");
require("../Warnings/warning.less");
require("./selectField.less");
function isGroup(optionOrGroup) {
    return optionOrGroup.options !== undefined;
}
exports.isGroup = isGroup;
function flattenOptionsOrGroups(optionsOrGroups) {
    return optionsOrGroups.map(function (optionOrGroup) {
        if (isGroup(optionOrGroup))
            return optionOrGroup.options;
        return [optionOrGroup];
    }).reduce(function (previousOptions, currentOptions) { return previousOptions.concat(currentOptions); }, []);
}
var NoHighlightSelectionBehavior;
(function (NoHighlightSelectionBehavior) {
    NoHighlightSelectionBehavior[NoHighlightSelectionBehavior["Reset"] = 0] = "Reset";
    NoHighlightSelectionBehavior[NoHighlightSelectionBehavior["Clear"] = 1] = "Clear";
})(NoHighlightSelectionBehavior = exports.NoHighlightSelectionBehavior || (exports.NoHighlightSelectionBehavior = {}));
var SelectField = /** @class */ (function (_super) {
    __extends(SelectField, _super);
    function SelectField(props) {
        var _this = _super.call(this, props) || this;
        _this.noResultsText = "No results";
        /* note: this is just a cached list of the rendered (filtered) options for keyboard navigation */
        _this.renderedOptions = [];
        _this.selectedItemRef = null;
        _this.selectedItemScrollAlignment = 'Bottom';
        _this.renderSelectFieldFlyout = function () {
            var header = _this.props.renderHeader
                ? _this.props.renderHeader()
                : null;
            var customFooter = _this.props.renderFooter
                ? _this.props.renderFooter(_this.selectHighlightedOption)
                : null;
            /* note: defaultProps will ensure filterOptions is not undefined */
            var filterOptions = _this.props.filterOptions;
            var filteredOptionsOrGroups = _this.state.filtering
                ? _this.props.options.map(function (optionOrGroup) {
                    if (isGroup(optionOrGroup))
                        return __assign(__assign({}, optionOrGroup), { options: filterOptions(optionOrGroup.options, _this.state.displayedInputValue) });
                    return optionOrGroup;
                }).filter(function (optionOrGroup) {
                    if (isGroup(optionOrGroup))
                        return !!optionOrGroup.options.length;
                    return !!filterOptions([optionOrGroup], _this.state.displayedInputValue).length;
                })
                : _this.props.options;
            var isCurrentValueMissing = _this.isCurrentValueMissingInOptions(flattenOptionsOrGroups(filteredOptionsOrGroups));
            var filteredOptionsOrGroupsWithMissingItem = isCurrentValueMissing
                ? __spreadArrays(filteredOptionsOrGroups, [_this.props.value]) : filteredOptionsOrGroups;
            _this.renderedOptions = flattenOptionsOrGroups(filteredOptionsOrGroupsWithMissingItem);
            var selectFieldOptions = filteredOptionsOrGroupsWithMissingItem.map(function (optionOrGroup) {
                if (!isGroup(optionOrGroup))
                    return _this.renderSelectFieldOption(optionOrGroup);
                var id = idGenerator_1.GenerateId();
                return React.createElement(React.Fragment, { key: id },
                    React.createElement("li", { className: 'optgroup', id: id }, optionOrGroup.label),
                    React.createElement("span", { role: "group", "aria-labelledby": id }, optionOrGroup.options.map(function (option) { return _this.renderSelectFieldOption(option); })));
            });
            var footer;
            if (_this.props.allowCustomInput) {
                var currentValue_1 = _this.props.value;
                var displayLink = !currentValue_1 || arrayExtensions_1.find(_this.renderedOptions, function (option) { return option.value == currentValue_1.value; });
                /* note: this hides or shows the label and link in order to resolve an issue with clicking on the link causing the
                  * dropdown to close (because the link is removed from the dom and thus flyout thinks the click is outside the flyout)
                  */
                var linkStyle = { display: displayLink ? "" : "none" };
                var labelStyle = { display: displayLink ? "none" : "" };
                var customOptionText = _this.props.customOptionText || 'Custom value';
                footer = React.createElement("div", { className: "custom-value-item" },
                    React.createElement(React.Fragment, null,
                        React.createElement(link_1.Link, { className: "custom-value-link", onClick: _this.onCustomValueClick, style: linkStyle }, customOptionText),
                        React.createElement("span", { className: "custom-value-button", onClick: _this.onCustomValueClick, style: linkStyle })),
                    React.createElement(React.Fragment, null,
                        React.createElement("span", { className: "custom-value-label", style: labelStyle }, customOptionText),
                        React.createElement("span", { className: "clear-custom-value-button", onClick: _this.onClearCustomValueClick, style: labelStyle })));
            }
            else {
                var banner = _this.props.banner
                    ? React.createElement("div", { className: "banner" }, _this.props.banner)
                    : null;
                footer = _this.state.filtering && _this.renderedOptions.length === 0
                    ? React.createElement("div", { className: "no-results", id: _this.getNoResultsOptionId() }, _this.noResultsText)
                    : banner;
            }
            return React.createElement(React.Fragment, null,
                React.createElement("div", { id: _this.state.generatedFlyoutId, role: "listbox" },
                    React.createElement("div", { onClick: _this.focusInput }, header),
                    React.createElement("ul", { "aria-label": "Options" }, selectFieldOptions),
                    React.createElement("div", { onClick: _this.focusInput },
                        customFooter,
                        footer)));
        };
        _this.renderSelectFieldOption = function (option) {
            var isSelected = option.value === _this.state.highlightedOptionValue;
            var userClasses = (_this.props.getListItemClasses && _this.props.getListItemClasses(option)) || undefined;
            var optionClasses = classNames("option", userClasses, { "selected": isSelected });
            var optionId = _this.getOptionId(option.value);
            if (_this.props.renderOption)
                return React.createElement("li", { className: optionClasses, key: option.value, onClick: function () { return _this.selectOptionAndClose(option); }, id: optionId }, _this.props.renderOption(option, isSelected, _this.state.filtering, SelectField.getFilterRegEx(_this.state.displayedInputValue)));
            return _this.state.filtering
                ? React.createElement(FilteredSelectListItem, { option: option, isSelected: isSelected, selectedItemRef: function (ref) { return _this.selectedItemRef = ref; }, filterRegEx: SelectField.getFilterRegEx(_this.state.displayedInputValue), selectOption: _this.selectOptionAndClose, userClasses: userClasses, key: option.value, id: optionId })
                : React.createElement(UnfilteredSelectListItem, { option: option, isSelected: isSelected, selectedItemRef: function (ref) { return _this.selectedItemRef = ref; }, selectOption: _this.selectOptionAndClose, userClasses: userClasses, key: option.value, id: optionId });
        };
        _this.isCurrentValueMissingInOptions = function (options) {
            /* note: if we are not filtering, make sure the current value is included in the list of options */
            var currentValue = _this.props.value;
            return !!(!_this.state.filtering
                && !_this.props.allowCustomInput
                && currentValue
                && currentValue.value
                && !arrayExtensions_1.find(options, function (o) { return o.value == currentValue.value; }));
        };
        _this.findExactMatchOption = function (options, inputValue) {
            return arrayExtensions_1.find(options, function (option) { return option.text === inputValue; });
        };
        _this.findPreviouslyMatchingOption = function (options) {
            return arrayExtensions_1.find(options, function (option) { return option.value === _this.state.highlightedOptionValue; });
        };
        _this.findFirstOption = function (options) {
            return options.length > 0 ? options[0] : null;
        };
        _this.onInputChange = function (e) {
            var inputValue = e.currentTarget.value;
            if (_this.props.onInputChange) {
                _this.props.onInputChange(inputValue);
            }
            var nonGroupedOptions = flattenOptionsOrGroups(_this.props.options);
            /* note: defaultProps will ensure filterOptions is not undefined */
            var filterOptions = _this.props.filterOptions;
            var filteredOptions = inputValue !== '' ? filterOptions(nonGroupedOptions, inputValue) : nonGroupedOptions;
            var highlightedOption;
            if (inputValue === '')
                highlightedOption = _this.findFirstOption(filteredOptions);
            else
                highlightedOption = _this.findExactMatchOption(filteredOptions, inputValue)
                    || _this.findPreviouslyMatchingOption(filteredOptions)
                    || _this.findFirstOption(filteredOptions);
            var newHighlightedOptionValue = highlightedOption ? highlightedOption.value : "";
            _this.setState({
                dropdownIsOpen: true,
                displayedInputValue: inputValue,
                filtering: !!inputValue,
                highlightedOptionValue: newHighlightedOptionValue
            });
        };
        _this.selectOptionAndClose = function (selectedOption) {
            _this.setState({ dropdownIsOpen: false, filtering: false, displayedInputValue: selectedOption.text }, function () { return _this.selectOption(selectedOption); });
            _this.focusInput();
        };
        _this.selectOption = function (selectedOption) {
            _this.props.onChange(selectedOption);
        };
        _this.scrollToSelectedItem = function () {
            var selectedLi = _this.selectedItemRef;
            var containerUl = selectedLi.parentNode;
            if (_this.selectedItemScrollAlignment === 'Top')
                containerUl.scrollTop = selectedLi.offsetTop;
            else if (_this.selectedItemScrollAlignment === 'Bottom')
                containerUl.scrollTop = selectedLi.offsetTop + selectedLi.offsetHeight - containerUl.clientHeight;
            else // Center
                containerUl.scrollTop = selectedLi.offsetTop + selectedLi.offsetHeight / 2 - containerUl.clientHeight / 2;
        };
        _this.toggleDropdown = function () {
            if (!_this.state.dropdownIsOpen)
                _this.selectedItemScrollAlignment = 'Center';
            _this.setState(function (prevState) {
                var isOpen = !prevState.dropdownIsOpen;
                var filtering = prevState.filtering && isOpen;
                var displayedInputValue = filtering
                    ? prevState.displayedInputValue
                    : (_this.props.value ? _this.props.value.text : "");
                return { dropdownIsOpen: isOpen, filtering: filtering, displayedInputValue: displayedInputValue };
            });
        };
        _this.selectHighlightedOption = function () {
            var highlightedOption = arrayExtensions_1.find(_this.renderedOptions, function (o) { return o.value == _this.state.highlightedOptionValue; });
            if (highlightedOption) {
                _this.setState({
                    dropdownIsOpen: false,
                    filtering: false,
                    displayedInputValue: highlightedOption.text
                }, function () { return _this.selectOption(highlightedOption); });
            }
            else {
                if (_this.props.allowCustomInput) {
                    _this.setState({
                        dropdownIsOpen: false,
                        filtering: false
                    }, function () { return _this.selectOption({ value: _this.state.displayedInputValue, text: _this.state.displayedInputValue }); });
                }
                else {
                    if (_this.props.noHighlightSelectionBehavior === NoHighlightSelectionBehavior.Reset) {
                        _this.resetState();
                    }
                    else {
                        _this.setState({
                            dropdownIsOpen: false,
                            filtering: false,
                            displayedInputValue: ""
                        }, function () { return _this.selectOption({ value: "", text: "" }); });
                    }
                }
            }
        };
        _this.onFocus = function (event) {
            document.addEventListener("keydown", _this.handleKeyDown);
            if (_this.props.onFocus)
                _this.props.onFocus(event);
        };
        _this.onBlur = function (event) {
            document.removeEventListener("keydown", _this.handleKeyDown);
            if (_this.props.onBlur)
                _this.props.onBlur(event);
        };
        _this.handleKeyDown = function (e) {
            switch (e.keyCode) {
                case Matrix.Keys.Esc:
                    _this.resetState();
                    break;
                case Matrix.Keys.DownArrow:
                    _this.handleDownArrow();
                    break;
                case Matrix.Keys.UpArrow:
                    _this.highlightPreviousOption();
                    break;
                case Matrix.Keys.Enter:
                    _this.selectHighlightedOption();
                    break;
                case Matrix.Keys.Tab:
                    if (_this.props.onTab) {
                        _this.props.onTab(e);
                    }
                    _this.selectHighlightedOption();
                    break;
            }
        };
        _this.resetState = function () {
            var highlightedOptionValue = _this.props.value ? _this.props.value.value : "";
            _this.setState({
                dropdownIsOpen: false,
                displayedInputValue: _this.props.value ? _this.props.value.text : "",
                filtering: false,
                highlightedOptionValue: highlightedOptionValue
            });
        };
        _this.onDropdownButtonClick = function () {
            /* note: the FlyoutToggle component will handle opening the flyout */
            _this.focusInput();
        };
        _this.onCustomValueClick = function () {
            _this.focusAndSelectInput();
            _this.selectOption({ value: _this.state.displayedInputValue, text: _this.state.displayedInputValue });
        };
        _this.onClearCustomValueClick = function () {
            _this.focusAndSelectInput();
            var currentDisplayedInputValue = _this.state.displayedInputValue;
            _this.selectOption({ value: "", text: "" });
            /* note: calling selectOption will trigger the component to receive updated props, which will overwrite
              the displayed value, so we need to set it explicitly */
            setTimeout(function () { return _this.setState({ displayedInputValue: currentDisplayedInputValue }); }, 0);
        };
        _this.handleDownArrow = function () {
            var dropdownIsOpen = _this.state.dropdownIsOpen;
            if (dropdownIsOpen) {
                _this.highlightNextOption();
                return;
            }
            _this.selectedItemScrollAlignment = 'Center';
            _this.setState({
                dropdownIsOpen: true
            });
        };
        _this.highlightNextOption = function () {
            var indexOfCurrentHighlightedOption = arrayExtensions_1.findIndex(_this.renderedOptions, function (option) { return option.value === _this.state.highlightedOptionValue; });
            if (indexOfCurrentHighlightedOption === _this.renderedOptions.length - 1)
                return;
            _this.selectedItemScrollAlignment = 'Bottom';
            var highlightedOptionValue = indexOfCurrentHighlightedOption < 0
                ? _this.renderedOptions.length > 0 ? _this.renderedOptions[0].value : ""
                : _this.renderedOptions[indexOfCurrentHighlightedOption + 1].value;
            _this.setState({ highlightedOptionValue: highlightedOptionValue });
        };
        _this.highlightPreviousOption = function () {
            if (!_this.state.dropdownIsOpen) {
                return;
            }
            var indexOfCurrentHighlightedOption = arrayExtensions_1.findIndex(_this.renderedOptions, function (option) { return option.value === _this.state.highlightedOptionValue; });
            if (indexOfCurrentHighlightedOption > 0) {
                _this.selectedItemScrollAlignment = 'Top';
                _this.setState({
                    highlightedOptionValue: _this.renderedOptions[indexOfCurrentHighlightedOption - 1].value
                });
            }
        };
        _this.focusInput = function () {
            if (_this.inputElement) {
                _this.inputElement.focus();
            }
        };
        _this.focusAndSelectInput = function () {
            if (_this.inputElement) {
                _this.inputElement.focus();
                _this.inputElement.select();
            }
        };
        _this.state = {
            generatedId: "selectfield-" + idGenerator_1.GenerateId(),
            generatedFlyoutId: "selectfieldflyout-" + idGenerator_1.GenerateId(),
            dropdownIsOpen: false,
            displayedInputValue: _this.props.value ? _this.props.value.text : "",
            filtering: false,
            highlightedOptionValue: _this.props.value ? _this.props.value.value : ""
        };
        if (props.customOptionText && !props.allowCustomInput)
            console.warn('You provided customOptionText without allowCustomInput being enabled. This has no effect.');
        return _this;
    }
    SelectField.prototype.getOptionId = function (optionValue) {
        return this.state.generatedFlyoutId + "-selectedoption-" + optionValue;
    };
    //When typing to filter the results, if there are none, we want the screen reader to report 'No Results'
    SelectField.prototype.getNoResultsOptionId = function () {
        return this.getOptionId("");
    };
    SelectField.prototype.render = function () {
        var _this = this;
        var _a = this.props, userClasses = _a.className, disabled = _a.disabled, required = _a.required, flyoutSizeMode = _a.flyoutSizeMode, errorMessage = _a.errorMessage, title = _a.title;
        var _b = this.state, dropdownIsOpen = _b.dropdownIsOpen, displayedInputValue = _b.displayedInputValue;
        var fieldClasses = classNames('dropdown-field');
        var inputId = this.props.id || this.state.generatedId;
        var inputClasses = classNames('dropdown-input', userClasses, {
            'required': required
        });
        var dropdownFlyout = dropdownIsOpen
            ? {
                key: 'dropdownFlyout',
                contents: this.renderSelectFieldFlyout(),
                positioningElementId: inputId,
                flyoutClassName: 'dropdown-flyout',
                sizeMode: flyoutSizeMode || flyout_1.FlyoutSizeMode.SizeToPositioningElement,
                suppressAnimation: true
            }
            : null;
        //This is the ARIA 1.0 combobox pattern.  NVDA would not appropriately report the field as a combobox using 1.1, and there are no plans to deprecate 1.0
        //https://www.w3.org/TR/wai-aria-practices/#combobox
        return React.createElement(flyoutToggle_1.FlyoutClickToggle, { flyout: dropdownFlyout, toggleClickHandler: this.toggleDropdown, onClickOutsideFlyout: this.selectHighlightedOption, disabled: disabled },
            React.createElement("div", { className: fieldClasses },
                React.createElement("input", __assign({ id: inputId, value: displayedInputValue || "", type: "text", autoComplete: "off", disabled: disabled }, errorUtils_1.toErrorProps(inputClasses, title, errorMessage), { onFocus: this.onFocus, onBlur: this.onBlur, onChange: this.onInputChange, ref: function (input) { return _this.inputElement = input; }, maxLength: this.props.maxLength, role: "combobox", "aria-required": required, "aria-activedescendant": this.getOptionId(this.state.highlightedOptionValue), "aria-controls": this.state.dropdownIsOpen ? this.state.generatedFlyoutId : "", "aria-owns": this.state.dropdownIsOpen ? this.state.generatedFlyoutId : "", "aria-expanded": this.state.dropdownIsOpen, "aria-autocomplete": "list" })),
                (!this.props.allowCustomInput || this.props.includeNewButton) &&
                    React.createElement("button", { className: classNames("dropdown-button", { new: this.props.includeNewButton }), tabIndex: -1, disabled: disabled, role: "button", "aria-label": "Show options", onClick: this.onDropdownButtonClick })));
    };
    SelectField.prototype.componentDidMount = function () {
        var input = this.inputElement;
        if (input && this.props.autoFocus)
            requestAnimationFrame(function () { return input.focus(); });
    };
    SelectField.prototype.componentWillReceiveProps = function (nextProps) {
        var nextValue = nextProps.value && nextProps.value.value;
        var currentValue = this.props.value && this.props.value.value;
        var valueChanged = nextValue != currentValue;
        var valueCleared = valueChanged && (!nextProps.value || !nextProps.value.value);
        var displayedInputValue = valueChanged || valueCleared
            ? (nextProps.value ? nextProps.value.text : "")
            : this.state.displayedInputValue;
        var filtering = displayedInputValue
            ? this.state.filtering
            : false;
        /* note: the goal here is to highlight the new value if it has changed, otherwise keep the existing selection.
           If we are filtering, the filtered options may not contain the value, so we default to the first value in the
           filtered list in that case (or nothing) */
        var highlightedOptionValue = "";
        if (valueChanged && !filtering && nextProps.value && nextProps.value.value) {
            /* note: if we are not filtering, we'll add the option for the current value (if it isn't already there) so we just want to highlight it */
            highlightedOptionValue = nextProps.value.value;
        }
        else {
            var desiredHighlightedOptionValue_1 = valueChanged ? (nextProps.value && nextProps.value.value) : this.state.highlightedOptionValue;
            if (!filtering && nextProps.value && nextProps.value.value && desiredHighlightedOptionValue_1 == (nextProps.value && nextProps.value.value)) {
                highlightedOptionValue = nextProps.value.value;
            }
            else {
                /* note: defaultProps will ensure filterOptions is not undefined */
                var nextFlattenedOptions = flattenOptionsOrGroups(nextProps.options);
                var nextFilterOptions = nextProps.filterOptions;
                var filteredOptions = filtering
                    ? nextFilterOptions(nextFlattenedOptions, displayedInputValue)
                    : nextFlattenedOptions;
                var highlightedOption = arrayExtensions_1.findOrFirst(filteredOptions, function (option) { return option.value == desiredHighlightedOptionValue_1; });
                highlightedOptionValue = highlightedOption ? highlightedOption.value : "";
            }
        }
        this.setState({ displayedInputValue: displayedInputValue, highlightedOptionValue: highlightedOptionValue, filtering: filtering });
    };
    SelectField.prototype.componentDidUpdate = function () {
        if (this.selectedItemRef && !$(this.selectedItemRef).isVisibleInParent($(this.selectedItemRef).parent()))
            this.scrollToSelectedItem();
    };
    SelectField.defaultFilter = function (options, filterText) {
        /* todo: if we wanted to override this, we could add a prop */
        /* e.g. the async wrapper may not want to do any client-side filtering, as it has already been done on the server */
        options = options || [];
        var filterRegEx = SelectField.getFilterRegEx(filterText);
        return options.filter(function (o) { return o.text.search(filterRegEx) >= 0; });
    };
    SelectField.getFilterRegEx = function (inputValue) {
        var escapedInput = inputValue.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
        return new RegExp("\\b" + escapedInput, 'gi');
    };
    /* note: this sets default values for the props when they are not specified by consumers */
    SelectField.defaultProps = {
        filterOptions: SelectField.defaultFilter,
        noHighlightSelectionBehavior: NoHighlightSelectionBehavior.Reset
    };
    return SelectField;
}(React.Component));
exports.SelectField = SelectField;
function UnfilteredSelectListItem(props) {
    var option = props.option, isSelected = props.isSelected, userClasses = props.userClasses;
    var optionClasses = classNames('option', userClasses, { 'selected': isSelected });
    return (React.createElement("li", { className: optionClasses, onClick: function () { return props.selectOption(option); }, ref: isSelected ? props.selectedItemRef : undefined, id: props.id }, option.text || '\u00A0'));
}
function FilteredSelectListItem(props) {
    var option = props.option, isSelected = props.isSelected, filterRegEx = props.filterRegEx, userClasses = props.userClasses;
    var optionClasses = classNames('option', userClasses, { 'selected': isSelected });
    return (React.createElement("li", { className: optionClasses, onClick: function () { return props.selectOption(option); }, ref: isSelected ? props.selectedItemRef : undefined, id: props.id },
        React.createElement(HighlightedSegments, { text: option.text, filterRegEx: filterRegEx })));
}
function HighlightedSegments(props) {
    var text = props.text, filterRegEx = props.filterRegEx;
    var textToHighlight = text || '\u00A0';
    var displaySegments = [];
    var match = null;
    var cursor = 0;
    var segmentIndex = 0;
    while ((match = filterRegEx.exec(textToHighlight)) !== null) {
        var matchedToken = match[0];
        var matchIndex = match.index;
        var matchLength = matchedToken.length;
        //Handle match at beginning of string
        if (match.index === 0) {
            displaySegments.push(React.createElement("span", { className: 'highlight', key: "segment-" + ++segmentIndex }, textToHighlight.substr(matchIndex, matchLength)));
        }
        else {
            //For matches later in the string, first add a segment from the current cursor to the current match, then add a segment for the match
            displaySegments.push(React.createElement("span", { key: "segment-" + ++segmentIndex }, textToHighlight.substring(cursor, match.index)));
            displaySegments.push(React.createElement("span", { className: 'highlight', key: "segment-" + ++segmentIndex }, textToHighlight.substr(matchIndex, matchLength)));
        }
        cursor = matchIndex + matchLength;
    }
    //If last match didn't extend to the end of the string, add one more segment for the remaining part of the string
    if (cursor < textToHighlight.length) {
        displaySegments.push(React.createElement("span", { key: "segment-" + ++segmentIndex }, textToHighlight.substring(cursor)));
    }
    return (React.createElement("span", { className: "text-ellipsis", style: { display: 'inline-block' } }, displaySegments));
}
exports.HighlightedSegments = HighlightedSegments;
function CreateNewFooter(props) {
    var onCreateNewClick = function () {
        props.onClick();
        props.closeFlyout();
    };
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', padding: '.6em .4em .5em .6em' } },
        React.createElement(link_1.Link, { style: { flex: '1 0 auto' }, onClick: onCreateNewClick, disabled: props.disabled, title: props.title }, "Create New"),
        React.createElement(link_1.Link, { className: 'button-add', onClick: onCreateNewClick, disabled: props.disabled, title: props.title })));
}
exports.CreateNewFooter = CreateNewFooter;
exports.LabeledSelectField = labeled_1.labeled(SelectField);
exports.LockToggleSelectField = lockToggle_1.lockToggle(SelectField);
